let businessFlow=[
    {title:"1、线上下单：",content:"客户根据自身业务需求，在普拉托商城选择产品并指定相关参数后下单，在相应界面填写收货地址、联系方式等基本信息。"},
    {title:"2、订单确认：",content:"普拉托接收到客户在商城提交的订单后，核对产品基本信息，并通过预留联系方式联系客户，就订单信息和业务细节与客户进行进一步确认。"},
    {title:'3、合同签订：',content:"订单确认后，普拉托与客户签订销售合同。"},
    {title:"4、产品生产：",content:"双方合同签订后，普拉托根据交期安排产品生产。"},
    {title:"5、物流发运：",content:"根据合同约定交货时间和方式，普拉托安排车辆将产品配送至客户指定地点，或者由客户到普拉托指定地点自提。"},
    {title:"6、售后服务：",content:"自产品到货验收合格之日起，普拉托根据合同约定提供质保服务"}
],
afterSale=[
    {title:'1、产品验收',content:"客户应于产品交付后3个工作日内对产品品牌、规格型号、数量等进行检查，并依照约定的质量要求和技术标准对产品进行验收；验收不合格的，客户应立即向普拉托提出书面异议，普拉托在接到异议后及时进行更换，直至验收合格。产品交付后3个工作日内未提出异议则视为产品通过验收。"},
    {title:'2、标准质保',content:"质保期 3 年，质保期从验收合格之日起开始计算，质保期内，产品正常使用情况下，因质量问题出现非人为损坏，将按以下规则免费更换：一年以内，一块坏托盘更换一块新托盘；第二年，二块坏托盘更换一块新托盘；第三年，三块坏托盘更换一块新托盘。"},
]
export {businessFlow,afterSale}